import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Company } from '../../classes/company';
import { Step } from '../../classes/step';
import { CompanyService } from '../../services/company.service';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-multiple-company-dashboard-page',
  templateUrl: './multiple-company-dashboard-page.component.html',
  styleUrls: ['./multiple-company-dashboard-page.component.scss']
})
export class MultipleCompanyDashboardPageComponent implements OnInit {

  company: Company = <Company>{ status: 'inprogress' };
  name: string = '';
  state: any = <any>{};
  steps: any[] = [];
  urls: any;
  incomplete: boolean = false;
  sub: any;
  orgId: number;
  isAdmin: boolean;
  error: string;
  user: any;
  finishedSteps: any[];
  currentStep: number;
  @ViewChild('submitModal') public submitModal: ModalDirective;

  constructor(
    private CompanyService: CompanyService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private UserService: UserService
  ) { }

  ngOnInit() {
    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.name = u.first_name;
        this.isAdmin = u.admin;

        this.sub = this.route.params.subscribe(params => {
          this.orgId = +params['orgId'];
          this.urls = <any>{
            'Add Users': `/onboarding/user/add/${this.orgId}`,
            'Add Departments': `/onboarding/department/${this.orgId}`,
            'Setup your Organization': `/onboarding/businessinfo/${this.orgId}`,
            'Upload Documents': this.isAdmin ? `/admin/documents/${this.orgId}` : `/onboarding/upload/${this.orgId}`,
            'Setup your Vacation Policies': `/onboarding/timeoff/${this.orgId}`,
          };
          console.log(u.organizations)
          if (u.organizations) {
            this.CompanyService.getCompany(this.orgId)
              .subscribe(company => {
                this.company = JSON.parse(company.organization);
                this.steps = JSON.parse(company.steps);
                this.finishedSteps = this.steps.filter((s) => {
                  return s[2]
                })
                let states = this.steps.map((s) => {
                  return s[2]
                })
                this.currentStep = 0;
                for (let i = 0; i < states.length; i++) {
                  if (states[i]) {
                    this.currentStep++
                  }
                  else {
                    break;
                  }

                }

                this.incomplete = this.steps.some(s => {
                  return !s[2];
                })
                this.state = JSON.parse(company.state);
              }, err => {
                console.log(err)
                if (err.status == 401) {
                  localStorage.clear();
                  this.router.navigate(['/']);
                }
              })
          }
          else {
            this.router.navigate(['/onboarding/success', this.orgId])
          }
        });
      });

    this.titleService.setTitle('Dashboard');
  }

  ngOnDestroy() {
    
  }

  complete() {
    this.router.navigate(['/onboarding/submit', this.orgId]);
  }

  showError() {
    let steps = this.steps
      .filter(s => {
        return !s[2]
      }).map(s => {
        return s[0]
      }).join(', ');
    this.error = `Please complete the following steps before clicking Submit: ${steps}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/multiple-company-dashboard-page/multiple-company-dashboard-page.component.ts